export default "__VITE_ASSET__b2402875__"